import "@fancyapps/fancybox";

$('[data-fancybox="gallery"]').fancybox({
    loop: true,
    wheel: false,
});
